import { Link, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaBoxOpen,
  FaShoppingCart,
  FaUsers,
  FaPlusCircle,
  FaSignOutAlt
} from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";
import "../css/admin.css";
function AdminSidebar() {

  const navigate = useNavigate();

  const logout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("user_id");
    localStorage.removeItem("name");
    localStorage.removeItem("email");

    navigate("/login");

  };

  return (

    <div className="admin-sidebar">

      <h2>SIPS ADMIN</h2>

<Link to="/admin/dashboard">
        <FaTachometerAlt />
        Dashboard
      </Link>

      <Link to="/admin/products">
        <FaBoxOpen />
        Products
      </Link>
<Link to="/admin/add-product">
 
  <FaPlusCircle />

  Add Product

</Link>
      <Link to="/admin/orders">
        <FaShoppingCart />
        Orders
      </Link>

      <Link to="/admin/users">
        <FaUsers />
        Users
      </Link>
<Link to="/admin/website">
  <FaGlobe />
  Website Management
</Link>
      <button onClick={logout}>
        <FaSignOutAlt />
        Logout
      </button>

    </div>

  );

}

export default AdminSidebar;